module.exports = __webpack_public_path__ + "img/yxrwgj-nav.3f47323.svg";